import { render, staticRenderFns } from "./Segment.vue?vue&type=template&id=e7101398&scoped=true&"
import script from "./Segment.vue?vue&type=script&lang=ts&"
export * from "./Segment.vue?vue&type=script&lang=ts&"
import style0 from "./Segment.vue?vue&type=style&index=0&id=e7101398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7101398",
  null
  
)

export default component.exports